/**
 * ECharts cannot read CSS variables. Callers pass these hex/rgb strings
 * into chart options. Values come from the computed tokens so both themes match.
 * Categorical slots and tones are the block palette (plan 2 §11.2.6).
 * @param {Element} [root]
 */
const PALETTE_VARS = ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5', '--chart-6', '--chart-7', '--chart-8'];
const PALETTE_FALLBACK = ['#ff4d12', '#1f4e79', '#1f7a4d', '#8a6a12', '#5c3d86', '#0f5f73', '#8e2f49', '#3b3d43'];
const TONE_FALLBACK = {
  good: '#1f7a4d',
  bad: '#c4381a',
  neutral: '#5b5e66',
  accent: '#ff4d12',
  critical: '#8f1d1d',
};

export function chartTheme(root) {
  const node = root || document.documentElement;
  const style = window.getComputedStyle(node);
  const pick = (name) => style.getPropertyValue(name).trim();
  const signal = pick('--signal') || '#ff4d12';
  return {
    background: pick('--bg-page'),
    surface: pick('--surface-card'),
    text: pick('--text-primary'),
    muted: pick('--text-muted'),
    accent: pick('--accent') || signal,
    border: pick('--border'),
    signal,
    palette: PALETTE_VARS.map((name, index) => pick(name) || PALETTE_FALLBACK[index]),
    tones: {
      good: pick('--tone-good') || TONE_FALLBACK.good,
      bad: pick('--tone-bad') || TONE_FALLBACK.bad,
      neutral: pick('--tone-neutral') || TONE_FALLBACK.neutral,
      accent: pick('--tone-accent') || signal,
      critical: pick('--tone-critical') || TONE_FALLBACK.critical,
    },
  };
}
